import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";


const ContactSuccess: React.FC = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f9fafb",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, type: "spring", stiffness: 100 }}
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <div
          style={{
            background:
              "linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(5, 150, 105, 0.1))",
            border: "2px solid #10b981",
            borderRadius: "20px",
            padding: "3rem 2rem",
            position: "relative",
            overflow: "hidden",
            boxShadow: "0 5px 20px rgba(0,0,0,0.07)",
          }}
        >
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            style={{ fontSize: "4rem", marginBottom: "1rem" }}
          >
            🎉
          </motion.div>

          <motion.h3
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            style={{
              color: "#065f46",
              marginBottom: "1rem",
              fontSize: "1.8rem",
              fontWeight: "bold",
            }}
          >
            Message Sent Successfully!
          </motion.h3>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            style={{
              fontSize: "1.1rem",
              color: "#047857",
              lineHeight: "1.6",
              marginBottom: "2rem",
            }}
          >
            Thank you for contacting OWS! 🚀 <br />
            We've received your message and will get back to you within 24
            hours.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            style={{ display: "flex", gap: "1rem", justifyContent: "center" }}
          >
            <Link
              to="/contact"
              className="cta-button"
              style={{
                background: "linear-gradient(135deg, #10b981, #059669)",
                color: "white",
                border: "none",
                borderRadius: "50px",
                padding: "0.75rem 2rem",
                fontSize: "1rem",
                fontWeight: 600,
                cursor: "pointer",
                textDecoration: "none",
                boxShadow: "0 4px 15px rgba(16, 185, 129, 0.3)",
                transition: "all 0.3s ease",
              }}
            >
              ✨ Send Another Message
            </Link>
            <Link
              to="/"
              className="cta-button"
              style={{
                background: "white",
                color: "#9C02CB",
                border: "2px solid #9C02CB",
                borderRadius: "50px",
                padding: "0.75rem 2rem",
                fontSize: "1rem",
                fontWeight: 600,
                cursor: "pointer",
                textDecoration: "none",
                transition: "all 0.3s ease",
              }}
            >
              Back to Home
            </Link>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default ContactSuccess;
